import classNames from 'classnames';

import HomeIcon from '@heroicons/react/20/solid/HomeIcon';
import { Button, ButtonProps } from '../../buttons/Button';
import { Card } from '../Card';
import { ButtonType } from '../../buttons/ButtonType';

import { ReactNode } from 'react';
import { ThemeText } from '../../../../context/theme/ThemeConstantsUpdated';
import { Size } from '../../../../constants';

const { mainText, secondaryText } = ThemeText;

export const ErrorCard = (props: Props) => {
  const { title, subTitle, onReset, primaryButtonProps } = props;

  return (
    <Card cornerStyle={Size.lg}>
      <div className="px-10 py-6 text-center sm:px-16">
        <h1 className={classNames(mainText, 'mt-4 text-3xl font-bold tracking-tight sm:text-5xl')}>{title}</h1>
        <h2 className={classNames(secondaryText, 'mt-4 text-xl leading-7')}>{subTitle}</h2>
        <div className="mt-8 flex items-center justify-center gap-x-6">
          {primaryButtonProps != null ? (
            <Button {...primaryButtonProps} />
          ) : (
            <Button onClick={onReset} buttonType={ButtonType.Primary} Icon={HomeIcon}>
              Homepage
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

type Props = {
  title: ReactNode;
  subTitle: ReactNode;
  onReset: () => void;
  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
};
